import { useStyles } from '@archipro-design/aria';
import type {
    PageBuilderModuleMetaProps,
    TextColumnProps,
} from '@modules/page-builder/types';
import { TextTypeEnum } from 'generated/graphql';
import {
    DoubleColumnContainer,
    SingleColumnContainer,
} from '../../common/pagebuilder.style';
import SingleParagraphModule from '../single-paragraph-module/SingleParagraphModule';

interface DuoParagraphModuleProps extends PageBuilderModuleMetaProps {
    columns: TextColumnProps[];
}

const DuoParagraphModule = ({ columns, meta }: DuoParagraphModuleProps) => {
    const { css } = useStyles();

    const [firstColumn, secondColumn] = columns;
    if (!firstColumn || !secondColumn) {
        return null;
    }
    const isSingleParagraph =
        firstColumn.textType === TextTypeEnum.Paragraph && !firstColumn.content;

    return (
        <div
            className={
                isSingleParagraph
                    ? css(SingleColumnContainer)
                    : css(DoubleColumnContainer)
            }
        >
            {isSingleParagraph ? (
                <SingleParagraphModule
                    key={secondColumn.id}
                    column={secondColumn}
                    meta={meta}
                />
            ) : (
                columns.map((column) => (
                    <SingleParagraphModule
                        key={column.id}
                        column={column}
                        meta={meta}
                    />
                ))
            )}
        </div>
    );
};

export default DuoParagraphModule;
